var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-pdf-app',{attrs:{"pdf":_vm.pdf,"config":_vm.config,"fileName":_vm.name,"theme":_vm.darkMode ? 'dark': 'light'},on:{"open":_vm.openHandler,"pages-rendered":_vm.pagesRenderedHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }